import TYPES from '@/modules/shared/types';

// Domain
import { CustomerKuspitMovementRepository } from '../../domain/repository';
import { MovementEntity } from '../../domain/entities/movement-entity';
import { SearchMovementDto } from '../../domain/dtos/search-movement-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class CustomerKuspitMovementHttpRepository
implements CustomerKuspitMovementRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/kuspit/movements/`;

  execute(dates: SearchMovementDto): Promise<Array<MovementEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint.concat(`${dates.initial_date}/`).concat(`${dates.final_date}/`))
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(JSON.stringify({
                  status_code: response.status,
                  message_error: message,
                }));
              }
            });
        })
        .catch(reject);
    });
  }
}
